import getCombatantIndexById from "./getCombatantIndexById";
import store from "../store/index";
//---------------------
// reduce action count
//---------------------
export default function reduceActionCount(parm) {
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  //--------------------
  // get combatant index
  //--------------------
  let idx = getCombatantIndexById(parm.id);
  //---------------------
  // reduce action count
  //---------------------
  combatants[idx].action_count--;
  //---------------------
  // reduce actual count
  //---------------------
  if (parm.actual) {
    combatants[idx].actual_action_count--;
  }
}
